import styled from "styled-components";

const CardSubtitle = styled.div`
  font-size: 14px;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text};s
`;

export default CardSubtitle;
